var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.5 4.5H0V5.5H0.5V4.5ZM11 5.5H11.5V4.5H11V5.5ZM11.5 5L11.8536 5.35355L12.2071 5L11.8536 4.64645L11.5 5ZM7.85355 0.646447L7.5 0.292893L6.79289 1L7.14645 1.35355L7.85355 0.646447ZM7.14645 8.64645L6.79289 9L7.5 9.70711L7.85355 9.35355L7.14645 8.64645ZM0.5 5.5H11V4.5H0.5V5.5ZM11.8536 4.64645L7.85355 0.646447L7.14645 1.35355L11.1464 5.35355L11.8536 4.64645ZM11.1464 4.64645L7.14645 8.64645L7.85355 9.35355L11.8536 5.35355L11.1464 4.64645Z","fill":"#111111"}));
}

Arrow.defaultProps = {"width":"13","height":"10","viewBox":"0 0 13 10","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
